import React from 'react'
import lazyRequire from './LazyRequire'
import { Route, BrowserRouter, Switch } from 'react-router-dom'

const Test = lazyRequire(() => import('./pages/demo/test'))
const Demo = lazyRequire(() => import('./pages/demo/demo'))
const Next1 = lazyRequire(() => import('./pages/demo/next1'))
const NextDemo = lazyRequire(() => import('./pages/demo/nextDemo'))
const ARDemo = lazyRequire(() => import('./pages/demo/arDemo'))

//登录
const Login = lazyRequire(() => import('./pages/login'))

//用户中心
const SelectCity = lazyRequire(() => import('./pages/userCenter/selectCity')) //选择城市

//行程
const Itineraries = lazyRequire(() => import('./pages/itineraries'))
const AddItineraries = lazyRequire(() => import('./pages/itineraries/addItineraries')) // 添加行程
const FlightListItineraries = lazyRequire(() => import('./pages/itineraries/queryList')) //航班查询列表
const FlightDetail = lazyRequire(() => import('./pages/itineraries/flightDetail')) //航班详情

//停车缴费
// const AsyncHome = asyncComponent(() => import("./containers/Home"));
const Parking = lazyRequire(() => import('./pages/parking'))
const Car = lazyRequire(() => import('./pages/parking/car'))
const Area = lazyRequire(() => import('./pages/parking/area'))
const Records = lazyRequire(() => import('./pages/parking/records'))
const Questions = lazyRequire(() => import('./pages/parking/questions'))
const ParkingFeeDetail = lazyRequire(() => import('./pages/parking/parkingFeeDetail'))
const ParkingOrderResult = lazyRequire(() => import('./pages/parking/parkingOrderResult'))

const BizDetail = lazyRequire(() => import('./pages/biz/bizDetail')) //店铺详情页面
const SecurityDetail = lazyRequire(() => import('./pages/security/securityDetail')) //快速安检详情页面
const SecurityCheck = lazyRequire(() => import('./pages/security/securityCheck')) //快速安检确认页面
const SecurityResult = lazyRequire(() => import('./pages/security/securityResult')) //快速安检结果页面
const RealName = lazyRequire(() => import('./pages/realName')) //实名认证页面
const AboutUs = lazyRequire(() => import('./pages/aboutUs')) //关于我们页面
const AboutUsMenuEntry = lazyRequire(() => import('./pages/aboutUs/MenuEntry')) // 关于我们导航和列表
const LiveScreen = lazyRequire(() => import('./pages/airport/liveScreen')) //机场大屏页面
const FlightScreen = lazyRequire(() => import('./pages/airport/liveScreen/flightScreen')) //机场航班大屏页面

const ParkingOrderDetail = lazyRequire(() => import('./pages/order/parkingOrderDetail')) // 停车订单详情页面
const AppDownload = lazyRequire(() => import('./pages/appDownload')) //下载app页面
const OrderInfoLink = lazyRequire(() => import('./pages/order/orderInfoLink')) //短链

// 在机场
const TelList = lazyRequire(() => import('./pages/airport/telList')) // 在机场常用电话页面
const BusList = lazyRequire(() => import('./pages/airport/bus/busList')) // 在机场地面交通列表页面
const BusDetail = lazyRequire(() => import('./pages/airport/bus/busDetail')) // 在机场地面公交详情页面
const RailList = lazyRequire(() => import('./pages/airport/rail/railList')) // 在机场轨道交通列表页面
const RailDetail = lazyRequire(() => import('./pages/airport/rail/railDetail')) // 在机场轨道交通详情页面
const CxfDetail = lazyRequire(() => import('./pages/airport/rail/cxfDetail')) // 在机场磁悬浮详情页面
const ShuttleBusList = lazyRequire(() => import('./pages/airport/shuttleBusList')) // 在机场摆渡车列表页面
const Taxi = lazyRequire(() => import('./pages/airport/taxi')) // 在机场出租车信息页面
const Article = lazyRequire(() => import('./pages/airport/article')) // 在机场信息详情页面
const LuggageStorage = lazyRequire(() => import('./pages/airport/luggageStorage')) // 在机场行李寄存页面
const CoachList = lazyRequire(() => import('./pages/airport/coachList')) // 在机场长途客运列表页面
const AirportList = lazyRequire(() => import('./pages/airport/list')) // 机场选择页
const AirportSearch = lazyRequire(() => import('./pages/airport/search')) // 机搜索

// 协议
const PrivacyPolicy = lazyRequire(() => import('./pages/protocol/privacyPolicy')) // 隐私政策
const SecurityServiceProtocol = lazyRequire(() =>
	import('./pages/protocol/securityServiceProtocol'),
) // 易安检服务协议
const ServiceProtocol = lazyRequire(() => import('./pages/protocol/serviceProtocol')) // 在机场服务协议
const MemberProtocol = lazyRequire(() => import('./pages/protocol/memberProtocol')) // 会员服务条款及协议

// import OrderDetail from './pages/orderDetail';
// import ProductDetail from './pages/productDetail';
// import ParkingOrderDetail from './pages/parkingOrderDetail';

const VipFusionList = lazyRequire(() => import('./pages/vip/fusionList')) // 贵宾休息室聚合页
const VipRoomDetail = lazyRequire(() => import('./pages/vip/vipRoomDetail')) // 贵宾休息室详情
const VipBooking = lazyRequire(() => import('./pages/vip/vipBooking')) // 贵宾休息室预订
const QueueServiceDetail = lazyRequire(() => import('./pages/vip/queueServiceDetail')) // 一条龙详情
const QueueBooking = lazyRequire(() => import('./pages/vip/queueBooking')) // 一条龙预订
const BookingSuccess = lazyRequire(() => import('./pages/vip/bookingSuccess')) // 预订成功
const BookingOrder = lazyRequire(() => import('./pages/vip/bookingOrder')) // 预订订单详情
const InvoiceConfirm = lazyRequire(() => import('./pages/invoice/invoiceConfirm')) // 发票确认
const AddInvoice = lazyRequire(() => import('./pages/invoice/addInvoice')) // 添加发票
const InvoiceDetail = lazyRequire(() => import('./pages/invoice/invoiceDetail')) // 发票详情
const InvoicePDF = lazyRequire(() => import('./pages/invoice/invoicePDF')) // 发票图片
const ScopeApplication = lazyRequire(() => import('./pages/vip/scopeApplication')) // 适用范围

// 伊斯坦布
const NotesForOut = lazyRequire(() => import('./pages/istanbul/notesForOut')) // 出境海关须知
const NotesForIn = lazyRequire(() => import('./pages/istanbul/notesForIn')) // 入境海关须知
const AirportActivities = lazyRequire(() => import('./pages/istanbul/airportActivities')) // 机场活动
const ServiceFacilities = lazyRequire(() => import('./pages/istanbul/serviceFacilities')) // 服务设施
const Lounge = lazyRequire(() => import('./pages/istanbul/lounge')) // 休息室
const IstanbulInfo = lazyRequire(() => import('./pages/istanbul/istanbulInfo')) // 信息
const IstanbulInfoT = lazyRequire(() => import('./pages/istanbul/istanbulInfoT')) // 信息

const PickUpDetail = lazyRequire(() => import('./pages/pickUpPerson/pickUpDetail')) // 接机详情
const PickUpBooking = lazyRequire(() => import('./pages/pickUpPerson/pickUpBooking')) // 接机预订
const AddFlight = lazyRequire(() => import('./pages/pickUpPerson/addFlight')) // 添加航班
const SelectFlight = lazyRequire(() => import('./pages/pickUpPerson/selectFlight')) // 选择航班
const PickUpSuccess = lazyRequire(() => import('./pages/pickUpPerson/pickUpSuccess')) // 预订成功
const PickUpOrder = lazyRequire(() => import('./pages/pickUpPerson/pickUpOrder')) // 预订订单详情
const PickUpOrderOutTime = lazyRequire(() => import('./pages/pickUpPerson/pickUpOrderOutTime')) // 超时订单详情
const ApplyRefund = lazyRequire(() => import('./pages/pickUpPerson/applyRefund')) // 申请退款
const SelectDate = lazyRequire(() => import('./pages/pickUpPerson/selectDate')) // 预约时间
const PlayVideo = lazyRequire(() => import('./pages/pickUpPerson/playVideo')) // 播放视频

const RightsPackageDetail = lazyRequire(() => import('./pages/rights/rightsPackageDetail')) // 权益包详情
const RightsBooking = lazyRequire(() => import('./pages/rights/rightsBooking')) // 权益包预定
const MyRightsPackageDetail = lazyRequire(() => import('./pages/rights/myRightsPackageDetail')) // 我的权益包详情
const RightsDetail = lazyRequire(() => import('./pages/rights/rightsDetail')) // 权益卡详情
const CouponsDetail = lazyRequire(() => import('./pages/rights/couponsDetail')) // 优惠券详情
const RightsRules = lazyRequire(() => import('./pages/rights/rightsRules')) // 使用及转赠规则
const RightsBookingSuccess = lazyRequire(() => import('./pages/rights/rightsBookingSuccess')) // 预订成功
const RightsOrder = lazyRequire(() => import('./pages/rights/rightsOrder')) // 权益订单

const SunriseCoupon = lazyRequire(() => import('./pages/sunrise/coupon')) // 优选会员权益券详情
const CivilAviationDetail = lazyRequire(() => import('./pages/civilAviation/detail')) // 民航人详情
const CivilAviationIntroduce = lazyRequire(() => import('./pages/civilAviation/introduce')) // 什么是民航人
const CivilAviationError = lazyRequire(() => import('./pages/civilAviation/validationFailed')) // 成为民航人失败
const RightsInfoDetail = lazyRequire(() => import('./pages/civilAviation/rightsInofDetail')) // 权益详情

const AbroadDetail = lazyRequire(() => import('./pages/abroad/detail')) // 出国宝详情
const AbroadBooking = lazyRequire(() => import('./pages/abroad/booking')) // 出国宝预定
const AddTripInfo = lazyRequire(() => import('./pages/abroad/addTripInfo')) // 添加行程信息
const AddPassportInfo = lazyRequire(() => import('./pages/abroad/addPassportInfo')) // 添加护照信息
const Search = lazyRequire(() => import('./pages/abroad/search')) // 搜索
const SelectInput = lazyRequire(() => import('./pages/abroad/selectInput')) // 多选填空
const AbroadBookingSuccess = lazyRequire(() => import('./pages/abroad/bookingSuccess')) // 预订成功
const AbroadOrder = lazyRequire(() => import('./pages/abroad/order')) // 预订订单

const ExchangeCoupon = lazyRequire(() => import('./pages/exchangeCoupon')) // 兑换券
const PdfDoc = lazyRequire(() => import('./pages/pdfDoc')) // pdf承载页

// 会员
const MemberDetail = lazyRequire(() => import('./pages/member/member'))
const MemberBooking = lazyRequire(() => import('./pages/member/booking'))
const MemberBookingSuccess = lazyRequire(() => import('./pages/member/bookingSuccess'))
const MemberUpgrade = lazyRequire(() => import('./pages/member/memberUpgrade'))
const BuyRecords = lazyRequire(() => import('./pages/member/buyRecords'))
const CommonProblems = lazyRequire(() => import('./pages/member/commonProblems'))
const EquityDetail = lazyRequire(() => import('./pages/member/equityDetail'))
const EquityList = lazyRequire(() => import('./pages/member/equityList'))
const EquityInfoDetail = lazyRequire(() => import('./pages/member/equityInfoDetail'))
//会员二期
const MineMember = lazyRequire(() => import('./pages/memberNew/mineMember/index'))
const MineBuyRecords = lazyRequire(() => import('./pages/memberNew/mineMember/buyRecord'))
const MineRefund = lazyRequire(() => import('./pages/memberNew/mineMember/refund'))
const EquityOrCouponDetail = lazyRequire(() => import('./pages/memberNew/equityOrCouponDetail'))

// 会员新
const MemberDetailNew = lazyRequire(() => import('./pages/memberNew/member'))
const MemberBookingNew = lazyRequire(() => import('./pages/memberNew/booking'))
const MemberBookingResultNew = lazyRequire(() => import('./pages/memberNew/bookingResult'))
const MemberBookingWelfare = lazyRequire(() => import('./pages/memberNew/welfare'))
// const TarnsferPage = lazyRequire(() => import('./pages/memberNew/transferPage'))

const FusionBizList = lazyRequire(() => import('./pages/fusion/list/biz')) // 商业混合列表页
const FusionMallItemList = lazyRequire(() => import('./pages/fusion/list/mallItem')) // 商城商品混合列表页
const FusionStoreList = lazyRequire(() => import('./pages/fusion/list/store')) // 商城店铺混合列表页

// PVG-浦东预约泊车(长时停车)
const LongParkingDetail = lazyRequire(() => import('./pages/longParking/detail')) // 详情
const LongParkingBooking = lazyRequire(() => import('./pages/longParking/booking')) // 预定
const LongParkingBookingDelay = lazyRequire(() => import('./pages/longParking/bookingDelay')) // 预定
const LongParkingBookingAfter = lazyRequire(() => import('./pages/longParking/bookingAfter')) // 预定
const LongParkingBookingSuccess = lazyRequire(() => import('./pages/longParking/bookingSuccess')) // 预订成功
const LongParkingBookingOrder = lazyRequire(() => import('./pages/longParking/order')) // 订单详情（先付费）
const LongParkingReserveOrder = lazyRequire(() => import('./pages/longParking/reserveOrder')) // 订单详情（后付费）

// SHA-虹桥预约泊车
const SHALongParkingDetail = lazyRequire(() => import('./pages/longParking/SHA/detail'))
const SHALongParkingBooking = lazyRequire(() => import('./pages/longParking/SHA/booking'))
const SHALongParkingBookingResult = lazyRequire(() =>
	import('./pages/longParking/SHA/bookingResult'),
)
const SHALongParkingOrder = lazyRequire(() => import('./pages/longParking/SHA/order'))

const RightsList = lazyRequire(() => import('./pages/rights/rightsList')) // 权益列表
const RightsDisableList = lazyRequire(() => import('./pages/rights/rightsDisableList')) // 权益失效列表

// 商城相关
const MallExpress = lazyRequire(() => import('./pages/mall/express')) // 线上订单快递追踪
const MallGoods = lazyRequire(() => import('./pages/mall/goods')) // 线上商城-首页-商品列表
const MallMarketingCfg = lazyRequire(() => import('./pages/mall/marketing/config')) // 线上商城-落地页配置
const MallMarketingNN = lazyRequire(() => import('./pages/mall/marketing/v1')) // 线上商城-N件N元-商品列表
const MallMarketingRule = lazyRequire(() => import('./pages/mall/marketing/v1/rule')) // 线上商城活动规则

// 多包裹
const MultiPackages = lazyRequire(() => import('./pages/mall/express/MultiPackages'))
const AddressList = lazyRequire(() => import('./pages/address/addressList')) // 地址列表

// 快速安检
const FastSecurityDetail = lazyRequire(() => import('./pages/fastSecurity/detail')) // 详情
const FastSecurityBooking = lazyRequire(() => import('./pages/fastSecurity/booking')) // 预定
const FastSecurityOrder = lazyRequire(() => import('./pages/fastSecurity/order')) // 订单

// 航班信息
const FlightInfo = lazyRequire(() => import('./pages/flight/index'))
// 电瓶车
const BatteryCarDetail = lazyRequire(() => import('./pages/batteryCar/detail')) // 详情
const BatteryCarBooking = lazyRequire(() => import('./pages/batteryCar/booking')) // 预定
const ElectronicOrder = lazyRequire(() => import('./pages/vip/bookingOrder/electronicOrder'))

const SeedLesson = lazyRequire(() => import('./pages/fusion/seedLesson'))

// 接送机
const AirportCar = lazyRequire(() => import('./pages/airportCar/home')) // 交通
const LiveLandingPage = lazyRequire(() => import('./pages/landingPage/live')) //直播落地页
const landingPageTripZhi = lazyRequire(() => import('./pages/landingPage/tripZhi')) //智行落地页
const landingPageTripZhiList = lazyRequire(() => import('./pages/landingPage/tripZhi/gatherList')) //智行聚合落地页
const identityDetailZhi = lazyRequire(() => import('./pages/identityDetail/zhiMember')) //智行信息页
const payLandingPage = lazyRequire(() => import('./pages/landingPage/payIndex')) // 支付落地中转页

// 行李管家
const PackageQA = lazyRequire(() => import('./pages/package/qa')) // 常见问题
const PackageRules = lazyRequire(() => import('./pages/package/rules')) // 行李规则
const PackageExpress = lazyRequire(() => import('./pages/package/express')) // 快递跟踪
const PackageServiceArea = lazyRequire(() => import('./pages/package/serviceArea')) // 服务范围
const PackageServiceAreaPlot = lazyRequire(() => import('./pages/package/serviceAreaPlot')) // 服务范围示意图
const PackageServicePointGuide = lazyRequire(() => import('./pages/package/servicePointGuide')) // 服务点指引
const PackageList = lazyRequire(() => import('./pages/package/list')) // 行李管家列表页
const PackageOrderDetail = lazyRequire(() => import('./pages/package/orderDetail')) // 行李管家订单详情
const PackageDetail = lazyRequire(() => import('./pages/package/detail')) // 行李管家商品详情
const PackageBooking = lazyRequire(() => import('./pages/package/booking')) // 行李管家预定
const PackageSearch = lazyRequire(() => import('./pages/package/search')) // 行李管家搜索
const PackageSearchList = lazyRequire(() => import('./pages/package/searchList')) // 行李管家搜索列表
const PackageAddFlight = lazyRequire(() => import('./pages/package/addFlight')) // 行李管家搜索航班
const PackageSelectFlight = lazyRequire(() => import('./pages/package/selectFlight')) // 行李管家选择航班
const PackageBookingResult = lazyRequire(() => import('./pages/package/bookingResult')) // 行李管家选择航班
const PackageRefund = lazyRequire(() => import('./pages/package/refund')) // 行李管家退款页面

// 积分
const IntegralList = lazyRequire(() => import('./pages/integral/list'))
const IntegralExplainPage = lazyRequire(() => import('./pages/integral/explain'))

//限时抢购
const FlashSale = lazyRequire(() => import('./pages/flashSale/list'))
const FlashSaleNew = lazyRequire(() => import('./pages/flashSale/seckill'))
const FlashSaleRule = lazyRequire(() => import('./pages/flashSale/rule'))

// 分销
const DistributionDetail = lazyRequire(() => import('./pages/distribution/detail')) // 我的分销
const EmployeePerformance = lazyRequire(() => import('./pages/distribution/employeePerformance')) // 员工业绩
const MyPerformance = lazyRequire(() => import('./pages/distribution/myPerformance')) // 员工业绩
const DistributionGuide = lazyRequire(() => import('./pages/distribution/guide')) // 引导页
const DistributionApply = lazyRequire(() => import('./pages/distribution/apply')) // 申请入驻
const DistributionBookingResult = lazyRequire(() => import('./pages/distribution/bookingResult')) // 申请结果页面
const DistributionCode = lazyRequire(() => import('./pages/distribution/myQrCode')) // 我的二维码
const MyCommission = lazyRequire(() => import('./pages/distribution/myCommission')) // 我的分销佣金
const DistributionInvitation = lazyRequire(() => import('./pages/distribution/invitation')) // 邀请有礼
const GetCoupons = lazyRequire(() => import('./pages/distribution/getCoupons')) // 邀请有礼落地页
const MyOrderRecord = lazyRequire(() => import('./pages/distribution/myOrderRecord')) // 我的订单收益记录
const MyWithdrawalRecord = lazyRequire(() => import('./pages/distribution/myWithdrawalRecord')) // 我的提现记录
const WithdrawDeposit = lazyRequire(() => import('./pages/distribution/withdrawDeposit')) // 提现
const WithdrawDetail = lazyRequire(() => import('./pages/distribution/withdrawDetail')) // 提现详情
const SunriseCouponNew = lazyRequire(() => import('./pages/sunrise/couponNew')) // 优选会员权益券详情(分销专用)

const EquityCodeDetail = lazyRequire(() => import('./pages/equity/detail'))
const EquityLinkDetail = lazyRequire(() => import('./pages/equity/linkDetail'))
const EquityConvert = lazyRequire(() => import('./pages/equity/convert')) // H5权益跳转
// 签到
const SignInfoIndex = lazyRequire(() => import('./pages/signInfo'))

// unionpay
const UpLogin = lazyRequire(() => import('./pages/unionpay/login'))

// 联华OK卡增加支付中转页、支付结果中转页
const OKCardPay = lazyRequire(() => import('./pages/okCard/pay')) // 支付中转页
const OKCardResult = lazyRequire(() => import('./pages/okCard/result')) // 支付结果中转页

const SpaceStation = lazyRequire(() => import('./pages/aRSpaceStation/spaceStation'))
const SpaceStationList = lazyRequire(() => import('./pages/aRSpaceStation/spaceStationList'))
const ARSearchPage = lazyRequire(() => import('./pages/aRSpaceStation/arSearch'))

// 交叉引流-下单送券列表
const OrderCouponList = lazyRequire(() => import('./pages/discounts/orderCouponList'))
// 权益卡接受页面
const equityCardReceive = lazyRequire(() => import('./pages/equityCard/equityCardReceive/index'))
// 权益卡介绍页面
const equityCardIntro = lazyRequire(() => import('./pages/equityCard/equityCardIntro'))
//新人礼包
const NewGiftBag = lazyRequire(() => import('./pages/newGiftBag/index'))
const NewGiftBagRules = lazyRequire(() => import('./pages/newGiftBag/giftBagRule'))

const CustomerService = lazyRequire(() => import('./pages/customerService'))
// 通用接送机
const AirportTransportDetail = lazyRequire(() => import('./pages/airportTransportation/datail')) // 接送机首页
const FlightSchedulePage = lazyRequire(() => import('./pages/airportTransportation/addFlight')) // 查询班机
const FlightBookingPage = lazyRequire(() => import('./pages/airportTransportation/booking')) // 信息确认
const FlightOrderPage = lazyRequire(() => import('./pages/airportTransportation/order')) // 接送机订单详情
const FlightRefundPage = lazyRequire(() => import('./pages/airportTransportation/refund')) // 接送机订单详情
const FlightPayResultPage = lazyRequire(() => import('./pages/airportTransportation/payResult')) // 接送机支付结果

//无感验证
const VerifyRobotPage = lazyRequire(() => import('./pages/verify/index'))

// nfr
const NfrIndex = lazyRequire(() => import('./pages/nfr/container/index'))
const NfrOrder = lazyRequire(() => import('./pages/nfr/order/orderList/index'))
const NfrOrderDetail = lazyRequire(() => import('./pages/nfr/order/orderDetail/index'))
const NfrBookingResult = lazyRequire(() => import('./pages/nfr/order/bookingResult/index'))
const NfrActivity = lazyRequire(() => import('./pages/nfr/activity/index'))
const NfrRealName = lazyRequire(() => import('./pages/nfr/nfrRealName/index')) //实名认证页面

const RedStarActivity = lazyRequire(() => import('./pages/redStar/payRank'))
const CreditsExchangePage = lazyRequire(() => import('./pages/creditsExchange/index'))

const SubscriptionExplainPage = lazyRequire(() => import('./pages/subscription/explain/index'))

// 民生银行拉新
const MsNewUser = lazyRequire(() => import('./pages/msNewUser/index'))

const WxJump = lazyRequire(() => import('./pages/wx/jumpMp'))
export default () => (
	<BrowserRouter>
		<Switch>
			<Route path='/test' component={Test} />
			<Route path='/demo' component={Demo} />
			<Route path='/next1' component={Next1} />
			<Route path='/next' component={NextDemo} />
			<Route path='/ardemo' component={ARDemo} />
			<Route path='/login' component={Login} />
			<Route path='/bizDetail' component={BizDetail} />
			<Route path='/realName' component={RealName} />
			<Route path='/aboutUs' component={AboutUs} />
			<Route path='/aboutUsMenuEntry' component={AboutUsMenuEntry} />
			<Route path='/parkingOrderDetail' component={ParkingOrderDetail} />
			<Route path='/appDownload' component={AppDownload} />
			<Route path='/orderInfoLink' component={OrderInfoLink} />

			{/* 我的-用户中心 */}
			<Route path='/userCenter/selectCity' component={SelectCity} />

			{/*预约安检*/}
			<Route path='/securityDetail' component={SecurityDetail} />
			<Route path='/securityCheck' component={SecurityCheck} />
			<Route path='/securityResult' component={SecurityResult} />

			{/*在机场*/}
			<Route path='/liveScreen' component={LiveScreen} />
			<Route path='/telList' component={TelList} />
			<Route path='/busList' component={BusList} />
			<Route path='/busDetail' component={BusDetail} />
			<Route path='/railList' component={RailList} />
			<Route path='/railDetail' component={RailDetail} />
			<Route path='/shuttleBusList' component={ShuttleBusList} />
			<Route path='/cxfDetail' component={CxfDetail} />
			<Route path='/taxi' component={Taxi} />
			<Route path='/article' component={Article} />
			<Route path='/luggageStorage' component={LuggageStorage} />
			<Route path='/coachList' component={CoachList} />
			<Route path='/airport/list' component={AirportList} />
			<Route path='/airport/search' component={AirportSearch} />

			<Route path='/parkingFeeDetail' component={ParkingFeeDetail} />
			<Route path='/parkingOrderResult' component={ParkingOrderResult} />

			{/*协议*/}
			<Route path='/privacyPolicy' component={PrivacyPolicy} />
			<Route path='/securityServiceProtocol' component={SecurityServiceProtocol} />
			<Route path='/serviceProtocol' component={ServiceProtocol} />
			<Route path='/memberProtocol' component={MemberProtocol} />

			<Route path='/vipFusionList' component={VipFusionList} />
			<Route path='/vipRoomDetail' component={VipRoomDetail} />
			<Route path='/vipBooking' component={VipBooking} />
			<Route path='/queueServiceDetail' component={QueueServiceDetail} />
			<Route path='/queueBooking' component={QueueBooking} />
			<Route path='/bookingSuccess' component={BookingSuccess} />
			<Route path='/bookingOrder' component={BookingOrder} />
			<Route path='/invoiceConfirm' component={InvoiceConfirm} />
			<Route path='/addInvoice' component={AddInvoice} />
			<Route path='/invoiceDetail' component={InvoiceDetail} />
			<Route path='/invoicePDF' component={InvoicePDF} />
			<Route path='/scopeApplication' component={ScopeApplication} />

			<Route path='/pickUpDetail' component={PickUpDetail} />
			<Route path='/pickUpBooking' component={PickUpBooking} />
			<Route path='/addFlight' component={AddFlight} />
			<Route path='/selectFlight' component={SelectFlight} />
			<Route path='/pickUpSuccess' component={PickUpSuccess} />
			<Route path='/pickUpOrder' component={PickUpOrder} />
			<Route path='/pickUpOrderOutTime' component={PickUpOrderOutTime} />
			<Route path='/applyRefund' component={ApplyRefund} />
			<Route path='/selectDate' component={SelectDate} />
			<Route path='/playVideo' component={PlayVideo} />

			<Route path='/rightsPackageDetail' component={RightsPackageDetail} />
			<Route path='/rightsBooking' component={RightsBooking} />
			<Route path='/myRightsPackageDetail' component={MyRightsPackageDetail} />
			<Route path='/rightsDetail' component={RightsDetail} />
			<Route path='/couponsDetail' component={CouponsDetail} />
			<Route path='/rightsRules' component={RightsRules} />
			<Route path='/rightsBookingSuccess' component={RightsBookingSuccess} />
			<Route path='/rightsOrder' component={RightsOrder} />

			<Route path='/sunriseCoupon' component={SunriseCoupon} />
			<Route path='/civilAviationDetail' component={CivilAviationDetail} />
			<Route path='/civilAviationIntroduce' component={CivilAviationIntroduce} />
			<Route path='/civilAviationError' component={CivilAviationError} />
			<Route path='/rightsInfoDetail' component={RightsInfoDetail} />

			<Route path='/abroadDetail' component={AbroadDetail} />
			<Route path='/abroadBooking' component={AbroadBooking} />
			<Route path='/addTripInfo' component={AddTripInfo} />
			<Route path='/addPassportInfo' component={AddPassportInfo} />
			<Route path='/search' component={Search} />
			<Route path='/selectInput' component={SelectInput} />
			<Route path='/abroadBookingSuccess' component={AbroadBookingSuccess} />
			<Route path='/abroadOrder' component={AbroadOrder} />

			<Route path='/notesForOut' component={NotesForOut} />
			<Route path='/notesForIn' component={NotesForIn} />
			<Route path='/airportActivities' component={AirportActivities} />
			<Route path='/serviceFacilities' component={ServiceFacilities} />
			<Route path='/lounge' component={Lounge} />
			<Route path='/istanbulInfo' component={IstanbulInfo} />
			<Route path='/istanbulInfoT' component={IstanbulInfoT} />
			<Route path='/notesForOut' component={NotesForOut} />
			<Route path='/notesForIn' component={NotesForIn} />
			<Route path='/airportActivities' component={AirportActivities} />
			<Route path='/serviceFacilities' component={ServiceFacilities} />
			<Route path='/lounge' component={Lounge} />
			<Route path='/istanbulInfo' component={IstanbulInfo} />
			<Route path='/istanbulInfoT' component={IstanbulInfoT} />

			<Route path='/memberDetail' component={MemberDetail} />
			<Route path='/memberBooking' component={MemberBooking} />
			<Route path='/memberBookingSuccess' component={MemberBookingSuccess} />
			<Route path='/memberUpgrade' component={MemberUpgrade} />
			<Route path='/buyRecords' component={BuyRecords} />
			<Route path='/commonProblems' component={CommonProblems} />
			<Route path='/equityDetail' component={EquityDetail} />
			<Route path='/equityList' component={EquityList} />
			<Route path='/equityInfoDetail' component={EquityInfoDetail} />
			{/* 行程 */}
			<Route path='/itineraries' component={Itineraries} exact />
			<Route path='/addItineraries' component={AddItineraries} exact />
			<Route path='/itineraries/flightDetail' component={FlightDetail} exact />
			<Route path='/itineraries/queryList' component={FlightListItineraries} exact />

			{/* 停车缴费 */}
			<Route path='/parking' component={Parking} exact />
			<Route path='/parking/car' component={Car} exact />
			<Route path='/parking/area' component={Area} exact />
			<Route path='/parking/records' component={Records} exact />
			<Route path='/parking/questions' component={Questions} exact />

			{/* 兑换券 */}
			<Route path='/exchangeCoupon' component={ExchangeCoupon} exact />
			{/*pdf承载页*/}
			<Route path='/pdfDoc' component={PdfDoc} exact />

			{/*混合列表页*/}
			<Route path='/fusion/list/biz' component={FusionBizList} exact />
			<Route path='/fusion/list/mallitem' component={FusionMallItemList} exact />
			<Route path='/fusion/list/store' component={FusionStoreList} exact />

			{/* PVG-浦东预约泊车(长时停车) */}
			<Route path='/longParkingDetail' component={LongParkingDetail} />
			<Route path='/longParkingBooking' component={LongParkingBooking} />
			<Route path='/longParkingBookingDelay' component={LongParkingBookingDelay} />
			<Route path='/longParkingBookingAfter' component={LongParkingBookingAfter} />
			<Route path='/longParkingBookingSuccess' component={LongParkingBookingSuccess} />
			<Route path='/longParkingBookingOrder' component={LongParkingBookingOrder} />
			<Route path='/longParkingReserveOrder' component={LongParkingReserveOrder} />
			{/* SHA-虹桥预约泊车 */}
			<Route path='/shaLongParkingDetail' component={SHALongParkingDetail} />
			<Route path='/shaLongParkingBooking' component={SHALongParkingBooking} />
			<Route path='/shaLongParkingBookingResult' component={SHALongParkingBookingResult} />
			<Route path='/shaLongParkingOrder' component={SHALongParkingOrder} />

			<Route path='/rightsList' component={RightsList} />
			<Route path='/rightsDisableList' component={RightsDisableList} />

			{/* 商城相关 */}
			<Route path='/mall/express' component={MallExpress} />
			<Route path='/mall/multi/packages' component={MultiPackages} />
			<Route path='/addressList' component={AddressList} />
			<Route path='/mall/goods/list' component={MallGoods} />
			<Route path='/mall/marketing/config' component={MallMarketingCfg} />
			<Route path='/mall/marketing/v1/list' component={MallMarketingNN} />
			<Route path='/mall/marketing/v1/rule' component={MallMarketingRule} />

			{/* 快速安检 */}
			<Route path='/fastSecurityDetail' component={FastSecurityDetail} />
			<Route path='/fastSecurityBooking' component={FastSecurityBooking} />
			<Route path='/fastSecurityOrder' component={FastSecurityOrder} />

			{/* 航班信息 */}
			<Route path='/flightInfo' component={FlightInfo} />
			<Route path='/flightScreen' component={FlightScreen} />

			{/* 电瓶车 */}
			<Route path='/batteryCarDetail' component={BatteryCarDetail} />
			<Route path='/batteryCarBooking' component={BatteryCarBooking} />
			<Route path='/electronicOrder' component={ElectronicOrder} />

			{/* 接送机 */}
			<Route path='/airportCar/home' component={AirportCar} />
			<Route path='/airportTransportation/detail' component={AirportTransportDetail} />
			<Route path='/airportTransportation/addFlight' component={FlightSchedulePage} />
			<Route path='/airportTransportation/booking' component={FlightBookingPage} />
			<Route path='/airportTransportation/order' component={FlightOrderPage} />
			<Route path='/airportTransportation/refund' component={FlightRefundPage} />
			<Route path='/airportTransportation/payResult' component={FlightPayResultPage} />
			{/* 直播落地页 */}
			<Route path='/landingPage/live' component={LiveLandingPage} />
			<Route path='/landingPage/payIndex' component={payLandingPage} />

			<Route path='/landingPage/tripZhi' component={landingPageTripZhi} />
			<Route path='/landingPage/tripZhiList' component={landingPageTripZhiList} />
			<Route path='/identityDetailZhi' component={identityDetailZhi} />
			{/* 孵化课程 */}
			<Route path='/seed/lesson' component={SeedLesson} />

			{/*行李管家*/}
			<Route path='/package/qa' component={PackageQA} />
			<Route path='/package/rules' component={PackageRules} />
			<Route path='/package/express' component={PackageExpress} />
			<Route path='/package/serviceArea/plot' component={PackageServiceAreaPlot} />
			<Route path='/package/serviceArea' component={PackageServiceArea} exact />
			<Route path='/package/servicePointGuide' component={PackageServicePointGuide} />
			<Route path='/package/list' component={PackageList} />
			<Route path='/package/orderDetail' component={PackageOrderDetail} />
			<Route path='/package/detail' component={PackageDetail} />
			<Route path='/package/booking' component={PackageBooking} />
			<Route path='/package/search' component={PackageSearch} />
			<Route path='/package/searchList' component={PackageSearchList} />
			<Route path='/package/addFlight' component={PackageAddFlight} />
			<Route path='/package/selectFlight' component={PackageSelectFlight} />
			<Route path='/package/bookingResult' component={PackageBookingResult} />
			<Route path='/package/refund' component={PackageRefund} />

			{/*积分列表*/}
			<Route path='/integral/list' component={IntegralList} exact />
			<Route path='/integral/explain' component={IntegralExplainPage} />

			{/*限时抢购*/}
			<Route path='/flashSale/list' component={FlashSale} />
			<Route path='/flashSale/listNew' component={FlashSaleNew} />
			<Route path='/flashSale/rule' component={FlashSaleRule} />
			{/* 分销 */}
			<Route path='/distributionDetail' component={DistributionDetail} />
			<Route path='/distributionGuide' component={DistributionGuide} />
			<Route path='/distributionApply' component={DistributionApply} />
			<Route path='/distributionBookingResult' component={DistributionBookingResult} />
			<Route path='/distributionCode' component={DistributionCode} />
			<Route path='/myCommission' component={MyCommission} />
			<Route path='/distributionInvitation' component={DistributionInvitation} />
			<Route path='/getCoupons' component={GetCoupons} />
			<Route path='/myOrderRecord' component={MyOrderRecord} />
			<Route path='/myWithdrawalRecord' component={MyWithdrawalRecord} />
			<Route path='/withdrawDeposit' component={WithdrawDeposit} />
			<Route path='/withdrawDetail' component={WithdrawDetail} />
			<Route path='/sunriseCouponNew' component={SunriseCouponNew} />

			<Route path='/equityCode/detail' component={EquityCodeDetail} />
			<Route path='/equityLink/detail' component={EquityLinkDetail} />
			<Route path='/equityConvert/detail' component={EquityConvert} />
			<Route path='/employeePerformance' component={EmployeePerformance} />
			<Route path='/myPerformance' component={MyPerformance} />
			{/*签到功能*/}
			<Route path='/signIn/index' component={SignInfoIndex} />
			<Route path='/upLogin' component={UpLogin} />

			{/* 联华OK卡增加支付中转页、支付结果中转页 */}
			<Route path='/okCardPay' component={OKCardPay} />
			<Route path='/okCardResult' component={OKCardResult} />

			{/* AR 空间站空能 */}
			<Route path='/aRSpaceStation/spaceStation' component={SpaceStation} />
			<Route path='/aRSpaceStation/spaceStationList' component={SpaceStationList} />
			<Route path='/aRSpaceStation/arSearch' component={ARSearchPage} />

			{/*	交叉引流-下单送券列表 */}
			<Route path='/orderCouponList' component={OrderCouponList} />
			{/*	权益卡接受页 */}
			<Route path='/equityCardReceive' component={equityCardReceive} />
			{/*	权益卡介绍 */}
			<Route path='/equityCardIntro' component={equityCardIntro} />
			{/*新人礼包*/}
			<Route path='/newGiftBag' component={NewGiftBag} />
			<Route path='/newGiftBagRules' component={NewGiftBagRules} />
			{/*会员二期*/}
			<Route path='/member/mineMember' component={MineMember} />
			<Route path='/member/mineBuyRecords' component={MineBuyRecords} />
			<Route path='/member/mineRefund' component={MineRefund} />
			<Route path='/member/equityOrCouponDetail' component={EquityOrCouponDetail} />
			<Route path='/member/detail' component={MemberDetailNew} />
			<Route path='/member/booking' component={MemberBookingNew} />
			<Route path='/member/bookingResult' component={MemberBookingResultNew} />
			<Route path='/member/welfare' component={MemberBookingWelfare} />
			<Route path='/member/tarnsfer' component={MemberDetailNew} />
			{/*客服中心*/}
			<Route path='/customerService' component={CustomerService} />
			<Route path='/verify' component={VerifyRobotPage} />
			{/*nfr*/}
			<Route path='/nfrIndex' component={NfrIndex} />
			<Route path='/nfrOrderList' component={NfrOrder} />
			<Route path='/nfrOrderDetail' component={NfrOrderDetail} />
			<Route path='/nfrBookingResult' component={NfrBookingResult} />
			<Route path='/nfrActivity' component={NfrActivity} />
			<Route path='/nfrRealName' component={NfrRealName} />
			{/*红星惠充值记录*/}
			<Route path='/redStar/payRank' component={RedStarActivity} />
			{/*积分兑换*/}
			<Route path='/creditsExchange/index' component={CreditsExchangePage} />

			<Route path='/remindDepreciate' component={SubscriptionExplainPage} />

			{/*民生银行拉新*/}
			<Route path='/msNewUser' component={MsNewUser} />

			<Route path='/wx/jump' component={WxJump} />
		</Switch>
	</BrowserRouter>
)
